export default __webpack_public_path__ + "static/media/4.c3483099.jpeg";